import { render, staticRenderFns } from "./bulkAdd.vue?vue&type=template&id=824dd308&"
import script from "./bulkAdd.vue?vue&type=script&lang=js&"
export * from "./bulkAdd.vue?vue&type=script&lang=js&"
import style0 from "./bulkAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports